document.addEventListener("DOMContentLoaded", function () {
    const select = document.getElementById("mnlReason");
    const subjectText = document.getElementById("mnlSubjectText");
    const topics = Array.from(document.querySelectorAll(".mnl-topic"));
    const formFields = document.querySelector(".mnl-form-fields");

    if (!select) return;

    function setRequired(container, shouldBeRequired) {
        container.querySelectorAll("[data-mnl-required]").forEach((el) => {
            el.required = shouldBeRequired;
        });
    }

    // Mark required fields once (so we can toggle reliably)
    if (formFields) {
        formFields.querySelectorAll("[required]").forEach((el) => {
            el.dataset.mnlRequired = "1";
        });
    }

    function update() {
        const key = select.value;

        // Update hidden subject text (label shown in dropdown)
        const opt = select.options[select.selectedIndex];
        subjectText.value = opt && opt.value ? opt.text.trim() : "";

        let active = null;

        topics.forEach((t) => {
            const on = t.dataset.topic === key;
            t.hidden = !on;

            // ✅ CRITICAL: only active topic inputs should be submitted
            t.querySelectorAll("input, textarea, select").forEach((el) => {
                el.disabled = !on;
            });

            if (on) active = t;
        });

        // Hide/show the email+message+button block
        if (formFields) {
            const hide = active && active.dataset.hideForm === "1";
            formFields.style.display = hide ? "none" : "flex";

            // If hidden, remove required to allow submit if you ever allow it (or keep as-is)
            formFields.querySelectorAll("[data-mnl-required]").forEach((el) => {
                el.required = !hide;
            });
        }
    }

    select.addEventListener("change", update);
    update();

    function updateAvailability() {
        const now = new Date();
        const day = now.getDay();   // 0=Sun ... 6=Sat
        const hour = now.getHours();

        const isWeekday = day >= 1 && day <= 5;
        const isBusinessHours = (hour >= 9 && hour < 12) || (hour >= 14 && hour < 17);

        document.querySelectorAll(".availability").forEach((el) => {
            if (isWeekday && isBusinessHours) {
                el.classList.remove("unavailable");
                el.classList.add("available");
                el.textContent = "Disponible";
            } else {
                el.classList.remove("available");
                el.classList.add("unavailable");
                el.textContent = "Indisponible";
            }
        });
    }

    updateAvailability();
    setInterval(updateAvailability, 60000);
});